import { createSelector } from 'reselect';
import { standortStateSelector } from '../standort';
import _ from 'lodash';
import { pendingResponse } from '../../fetchStatus';
import { serializeSearchParams } from '../../../helpers/UrlHelper';
import { extraParamsSelector } from '../util';

const selectedOptionsSelector = createSelector([extraParamsSelector], params => {
    const { selectedOptions } = params;
    if (!_.isPlainObject(selectedOptions)) {
        throw new Error(`Expected valid selectedOptions, instead got: ${selectedOptions}`);
    }
    return selectedOptions;
});

const completeWheelIdSelector = createSelector([extraParamsSelector], params => {
    const { completeWheelId } = params;
    if (_.isNil(completeWheelId) || !_.isString(completeWheelId) || _.isEmpty(completeWheelId)) {
        throw new Error(`Expected valid completeWheelId, instead got: ${completeWheelId}`);
    }
    return completeWheelId;
});

// Root
const completeWheelsStateSelector = createSelector([standortStateSelector], standortState => standortState.completeWheels);
export const completeWheelsSelectedOptionsSelector = createSelector(
    [completeWheelsStateSelector],
    completeWheelsState => completeWheelsState.selectedOptions
);

// TireOptions
const completeWheelOptionsResponseBySearchParamsSelector = createSelector(
    [completeWheelsStateSelector],
    completeWheelsState => completeWheelsState.completeWheelOptionsResponseBySearchParams
);
// used by completeWheels/completeWheel list
export const completeWheelsOptionsSearchParamsSelector = createSelector(
    [selectedOptionsSelector],
    ({ hsn, tsn, breite, hoehe, durchmesser }) => {
        return serializeSearchParams(
            {
                hsn,
                tsn,
                breite,
                hoehe,
                durchmesser,
            },
            { skipEmptyString: true }
        );
    }
);
export const completeWheelOptionsResponseSelector = createSelector(
    [completeWheelOptionsResponseBySearchParamsSelector, completeWheelsOptionsSearchParamsSelector],
    (completeWheelOptionsResponseBySearchParams, completeWheelsOptionsSearchParams) =>
        completeWheelOptionsResponseBySearchParams?.[completeWheelsOptionsSearchParams] ?? pendingResponse
);

// Tires
const completeWheelsResponseBySearchParamsSelector = createSelector(
    [completeWheelsStateSelector],
    completeWheelsState => completeWheelsState.completeWheelsResponseBySearchParams
);
export const completeWheelsSearchParamsSelector = createSelector(
    [selectedOptionsSelector],
    ({
        hsn,
        tsn,
        breite,
        hoehe,
        durchmesser,
        reifenHersteller,
        felgenHersteller,
        geschwindigkeitsindex,
        tragfaehigkeit,
        preisAb,
        preisBis,
        skip,
        limit,
    }) => {
        return serializeSearchParams(
            {
                hsn,
                tsn,
                breite,
                hoehe,
                durchmesser,
                geschwindigkeitsindex,
                tragfaehigkeit,
                reifenHersteller,
                felgenHersteller,
                preisAb,
                preisBis,
                skip,
                limit,
            },
            { skipEmptyString: true }
        );
    }
);
export const completeWheelsResponseSelector = createSelector(
    [completeWheelsResponseBySearchParamsSelector, completeWheelsSearchParamsSelector],
    (completeWheelsResponseBySearchParams, completeWheelsSearchParams) =>
        completeWheelsResponseBySearchParams?.[completeWheelsSearchParams] ?? pendingResponse
);

// CompleteWheel (Detail Page)
export const completeWheelResponseByIdSelector = createSelector(
    [completeWheelsStateSelector],
    completeWheelsState => completeWheelsState.completeWheelResponseById
);

export const completeWheelResponseSelector = createSelector(
    [completeWheelResponseByIdSelector, completeWheelIdSelector],
    (completeWheelResponseById, completeWheelId) => completeWheelResponseById?.[completeWheelId] ?? pendingResponse
);
